import Image from 'next/image'
import BookImage1 from 'public/images/book-1.png'
import MobBookImage from 'public/images/mob-book.png'
import BookImage2 from 'public/images/book-2.png'
import BookImage3 from 'public/images/book-3.png'
import { useRouter } from 'next/router'
export default function PersonalizedNotebookBanner() {
  const {locale} = useRouter();
  return (
    <div className={`personalized-notebook-banner ${locale === 'ar' ? '' : 'hidden'}`}>
      <div className="container-fluid mx-auto outside-container">
        <div className=" bg-success-500 rounded-xl p-2 flex flex-col lg:flex-row items-center px-8 py-6 lg:py-6">
          <div className="text-info lg:w-[42%] text-center lg:text-right mt-3">
            <h3 className="title text-2xl font-semibold text-primary 2xl:text-3xl">
              ابدأ بتصميم دفاتر طفلك الان
            </h3>
            <p className="text-primary text-lg mt-2">
              دفاتر لكل المواضيع بتصميم مميز وخاص.
              <br />
              في بصمتي نقدم لكم دفاتر مميزة التصاميم من الخارج ومسطرة بأجمل
              الأشكال من الداخل .<br />
              دفاتر تناسب كافة المواضيع: عربي، حساب، عبري، انجليزي وايضا رسم.
            </p>
            <a
              href="#notebooks"
              className="text-white hidden lg:inline-block font-bold py-3 bg-primary  text-center rounded-md w-full mt-4 lg:px-12 lg:w-auto">
              تصفح الدفاتر الان
            </a>
          </div>

          {/*
           *          <div className="mob-books-list  lg:hidden">
           *            <Image
           *              src={MobBookImage}
           *              width={300}
           *              height={140}
           *              alt="image"
           *              style={{
           *                height: 'auto',
           *                width: '100%',
           *              }} //The point is right there!
           *            />
           *
           *            <a
           *              href="#notebooks"
           *              className="text-white font-bold py-3 bg-primary block text-center rounded-md w-full mt-4 lg:px-12 lg:inline-block lg:w-auto">
           *              تصفح الدفاتر الان
           *            </a>
           *          </div>
           */}
          <div className="books-list flex flex-row items-center lg:w-[54%] lg:mr-6">
            <div className="lg:static grid grid-cols-3 ">
              <Image
                src={BookImage1}
                alt="image"
                style={{
                  height: 'auto',
                  width: '100%',
                  transform: 'rotate(35deg)',
                }} //The point is right there!
              />
              <Image
                src={BookImage2}
                alt="image"
                style={{
                  height: 'auto',
                  width: '100%',

                  transform: 'rotate(35deg)',
                }} //The point is right there!
              />

              <Image
                src={BookImage3}
                alt="image"
                style={{
                  height: 'auto',
                  width: '100%',
                  transform: 'rotate(35deg)',
                }} //The point is right there!
              />
            </div>
          </div>

          <a
            href="#notebooks"
            className="text-white inline-block lg:hidden font-bold py-3 bg-primary  text-center rounded-md w-full mt-4 lg:px-12 lg:w-auto">
            تصفح الدفاتر الان
          </a>
        </div>
      </div>
    </div>
  )
}
